// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"fd60b0d5","900":"6e7f763b"}[chunkId] + ".chunk.js");